<template>
  <div id="app">
    <!-- <app-header></app-header> -->
    <div class="container-fluid">
      <router-view/>
      <vue-snotify></vue-snotify>
    </div>
  </div>
</template>

<script>
// import appHeader from '@/components/common/app-header/app-header.vue';
export default {
  name: "App",
  components: {
    // appHeader
  }
};
</script>
<style>
.keyword-search{
  height: 2rem!important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue